import {
  GetCategoriesAndProductsWeb_CachedQuery,
  GetCategoriesAndProductsWeb_CachedQueryVariables
} from '@data/__generated__/types.main'
import {categoriesForRestaurantQuery} from '@data/queries/categories/categoriesForWebsite.main'
import isServerSide from '@helpers/misc/isServerSide'
import {useApolloQuery} from 'apollo-hooks'

export default function useCategoriesAndProducts({
  websiteId,
  menuId,
  format,
  preloadedCategories = {items: []},
  storeId,
  deliverAt
}) {
  // On the serverside, we skip this query and return the categories loaded at getStaticProps
  // These categories are obtained from the store default menu
  const result = useApolloQuery<
    GetCategoriesAndProductsWeb_CachedQuery,
    GetCategoriesAndProductsWeb_CachedQueryVariables
  >({
    query: categoriesForRestaurantQuery,
    variables: {websiteId, menuId, format, storeId, deliverAt},
    omit: isServerSide()
  })

  if (isServerSide() || !result.data) {
    return {categories: preloadedCategories}
  }

  return result
}
